import './tickets.scss';
import { useEffect, useState } from 'react';
import { RootState, TicketType } from 'types';
import { useParams, useHistory } from 'react-router-dom';
import Moment from 'react-moment';
import api from 'api';
import { useSelector } from 'react-redux';

function Tickets() {
    const params : any = useParams();
    const history = useHistory();
    const user = useSelector((state: RootState) => state.user);

    const [tickets, setTickets] = useState<TicketType[]>([]);
    const [activeTicketSelection, setActiveTicketSelection] = useState<number>(1);

    const markTicketAsCompleted = (id: number, val: boolean) => {
        const copiedTickets = [...tickets];
        const ticket = copiedTickets.find((x: TicketType) => x.TicketDetails.Id === id);
        ticket!.TicketDetails.IsCompleted = val;
        setTickets(copiedTickets);
        api.ticket.complete(id, user.Id, val);
    }

    const filterTickets = () => {
        if (activeTicketSelection === 1) {
            return tickets.filter((x: TicketType) => new Date(x.TicketDetails.DueDate!) > new Date() && !x.TicketDetails.IsCompleted);
        } else if (activeTicketSelection === 2) {
            return tickets.filter((x: TicketType) => new Date(x.TicketDetails.DueDate!) < new Date() && !x.TicketDetails.IsCompleted && x.TicketDetails.DueDate!);
        } else {
            return tickets.filter((x: TicketType) => x.TicketDetails.IsCompleted);
        }
    }

    useEffect(() => {
        api.ticket.getAll(params.clientId).then(data => {
            setTickets(data);
        })
    }, [params.clientId]);

    return (
        <div id="tickets" className="container">
            <div className="header">
                <span>My Tickets</span>
                <span className="view-all">View All</span>
                <div className="ticket-selection-switch">
                    <span className={activeTicketSelection === 1 ? 'active' : ''} onClick={() => setActiveTicketSelection(1)}>Upcoming</span>
                    <span className={activeTicketSelection === 2 ? 'active' : ''} onClick={() => setActiveTicketSelection(2)}>Overdue</span>
                    <span className={activeTicketSelection === 3 ? 'active' : ''} onClick={() => setActiveTicketSelection(3)}>Completed</span>
                </div>
            </div>
            <div className="tickets-container">
                <table>
                    <tbody>
                        {filterTickets().length ? (
                            filterTickets().map((x: any) => {
                                return (
                                    <tr className="ticket" key={x.Id} onClick={e => history.push(`/client/${params.clientId}/board/${x.BoardId}/ticket/${x.Id}`)}>
                                        <td className={x.IsCompleted ? 'completed' : ''} onClick={(e) => { e.stopPropagation(); markTicketAsCompleted(x.Id, !x.IsCompleted); }}><i className={`${x.IsCompleted ? 'fas' : 'far'} fa-check-circle`}></i></td>
                                        <td>{x.Heading}</td>
                                        <td className="due-date">{x.DueDate && <Moment format="DD-MM-yyyy">{x.DueDate}</Moment>}</td>
                                    </tr>
                                )
                            })
                        ) : (
                            <tr>
                                <td style={{color: "#000", fontSize: "14px", padding: "16px 0"}}>{activeTicketSelection === 1 ? 'No upcoming tickets' : activeTicketSelection === 2 ? 'No overdue tickets' : 'No tickets have been completed'}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Tickets;